/* eslint-disable */
export default {
  logging: 'A registar...',
  logCall: 'Registar chamada',
  editLog: 'Editar registo',
  select: 'Selecionar um registo correspondente',
  OnHold: 'Em espera',
  Ringing: 'A chamar',
  CallConnected: 'Chamada ligada',
  unknownUser: 'Utilizador desconhecido',
  unknownNumber: 'Anónimo',
  unavailable: 'Indisponível',
  viewDetails: 'Ver detalhes',
  addEntity: 'Criar novo',
  addLog: 'Registo',
  text: 'SMS',
  call: 'Ligar',
  missedCall: 'Não atendida',
  inboundCall: 'Recebida',
  outboundCall: 'Efetuada',
  answeredBy: 'Atendida por',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
